/**
 * Copyright © Veeam Software Group GmbH.
 */

import { PortalUserRoles } from '../../../entries/portal-user/enums';
import { baseConfig } from './base.config';

import type { BaseUserConfig } from '../interfaces';

export const siteAdministratorConfig: BaseUserConfig = {
    baseConfig: baseConfig,
    roleInt: PortalUserRoles.SiteAdministrator,
    roleName: PortalUserRoles[PortalUserRoles.SiteAdministrator] as keyof typeof PortalUserRoles,
    routes: [],
    sections: [],
};
